import { BaseControlBehaviour } from './BaseControlBehaviour';
declare let ymaps: any;
declare let Map: any;
export class AddressesTableBehaviour extends BaseControlBehaviour {
    constructor() {
        super('city-expander');
    }

    getInstalledTag() {
        return this.tagInstalled;
    }

    static installMap(mapElement: JQuery) {
        if (
            mapElement.data('longitude') == '' ||
            mapElement.data('latitude') == ''
        ) {
            mapElement.text(
                window.Localization.getString(
                    'Scripts_Shared_Infrastructure.AddressesTableBehaviour_2',
                    'Карта недоступна'
                )
            );
            return;
        }

        const myMap = new ymaps.Map(mapElement[0], {
            center: [mapElement.data('longitude'), mapElement.data('latitude')],
            zoom: 16,
        });

        Map = myMap;

        const clusterer = new ymaps.Clusterer({
                preset: 'islands#nightClusterIcons',
            }),
            myPlacemark = new ymaps.Placemark(
                [mapElement.data('longitude'), mapElement.data('latitude')],
                null,
                {
                    iconLayout: 'default#image',
                    iconImageHref:
                        '../../../Content/shared/images/mapmarker.png',
                    iconImageSize: [50, 65],
                    iconImageOffset: [-25, -68],
                }
            );

        myMap.controls.remove('trafficControl');
        myMap.controls.remove('searchControl');
        myMap.controls.remove('fullscreenControl');

        clusterer.add(myPlacemark);

        myMap.geoObjects.add(clusterer);
    }

    protected installBehaviour(element: HTMLElement): void {
        $(element).click(function () {
            const toToggle = $(this).siblings(
                '.addresses-body__expanded-table'
            );

            toToggle.slideToggle('medium', () => {
                $(this).trigger('endToggle');
            });

            const mapRow = $('.addresses-body__expanded-row', toToggle);

            if ($(this).hasClass('m-opened')) {
                $(this).removeClass('m-opened');
                $(this)
                    .parent('.addresses-body__table-row-wrapper')
                    .removeClass('m-opened');
                mapRow.unbind('click');
            } else {
                /*
                    var openedExpander = $('.addresses-body__table-row.m-opened');
                    if (openedExpander.length != 0) {
                        var table = openedExpander.siblings('.addresses-body__expanded-table');
                        table.toggle('medium');
                        openedExpander.removeClass('m-opened');
                        openedExpander.parent('.addresses-body__table-row-wrapper').removeClass('m-opened');
                        var openedRow = $('.addresses-body__expanded-row', table);
                        openedRow.unbind('click');
                    }
*/

                $(this).addClass('m-opened');
                $(this)
                    .parent('.addresses-body__table-row-wrapper')
                    .addClass('m-opened');

                mapRow.click(function () {
                    const map = $(this).siblings(
                        '.addresses-body__expanded-table-map'
                    );

                    const openedMap = $(
                        '.addresses-body__expanded-table-map.m-opened'
                    );

                    if (map.hasClass('m-opened')) {
                        map.removeClass('m-opened');
                        $(this)
                            .parent('.addresses-body__expanded-row-wrapper')
                            .removeClass('m-opened');
                    } else {
                        if (openedMap.length != 0) {
                            openedMap.removeClass('m-opened');
                            openedMap
                                .parent('.addresses-body__expanded-row-wrapper')
                                .removeClass('m-opened');
                            if (Map.length != 0) Map.destroy();
                        }

                        map.addClass('m-opened');
                        $(this)
                            .parent('.addresses-body__expanded-row-wrapper')
                            .addClass('m-opened');
                        const mapContainer = $('#adressmap', map);

                        if (mapContainer[0].innerHTML == '')
                            ymaps.ready(
                                AddressesTableBehaviour.installMap(mapContainer)
                            );

                        $(this).trigger('endToggle');
                    }
                });
            }
        });
    }
}

if(!window.Behaviours) window.Behaviours = {};
window.Behaviours.AddressesTableBehaviour = AddressesTableBehaviour;
